<ws-button styleClass="button-primary" (click)="openDialog()">Dialog öffnen</ws-button>

<ng-template #dialogTemplate>
	<h2 mat-dialog-title>Bilder</h2>
	<mat-dialog-content>
		<img
			*ngFor="let image of images"
			[src]="'/api/v1/images/' + image._id"
			(click)="selectImage(image._id)"
			class="selectable-image"
		/>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-button mat-dialog-close>Schließen</button>
	</mat-dialog-actions>
</ng-template>
